import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SwalService } from '../../shared/services/swal.service';
import { defaultNavItems, navItemsUserRole, navMedia, navUnits } from '../../_nav';
import { Subject } from 'rxjs';
import { UtilsService } from '../../services/utils.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './default-layout.component.html',
	styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
    public sidebarMinimized = false;
    public navItems = [];
    public username = null;
	topNavItems = [
		{ name: 'Dashboard', url: '/dashboard', icon: 'pi pi-home' },
		{ name: 'Reels', url: '/admin/svs/reels', icon: 'pi pi-video' },
		{ name: 'Layouts', url: '/admin/svs/layouts', icon: 'pi pi-images' },
		{ name: 'Media', url: '/admin/svs/media', icon: 'pi pi-image' },
		{ name: 'Unidades', url: '/admin/svs/units', icon: 'pi pi-truck' },
		{ name: 'Grupos de Unidades', url: '/admin/svs/groups', icon: 'pi pi-sitemap' }
	];

    private atComponentDestroy = new Subject();

    constructor(
        private authService: AuthService,
        private swal: SwalService,
        private router: Router
    ) {
    }

    ngOnInit(): void {
        this.navItems = [];
        this.authService.getProfile().subscribe(data => {
            this.username = data.user.name
        });

        if (this.authService.userRole) {
            this.getRolInformation(this.authService.userRole);
        } else {
            this.authService.getRolData().subscribe(data => {
                const roles = data.response;
                this.getRolInformation(roles[0]);
            });

        }
    }

	/**
	 * Toogle sidebar
	 * @param e
	 */
    toggleMinimize(e) {
        this.sidebarMinimized = e;
    }

	/**
	 * Logout the user
	 */
    logout() {
        this.authService.logout();
        localStorage.removeItem('access_token');
        localStorage.removeItem('netride_user_role');
        this.swal.success({
            text: ' ',
            onClose: () => {
                this.router.navigate(['/login']);
            }
        });
    }

    goProfile() {
        this.router.navigate(['/client/config/perfil']);
    }

	/**
	 * Get the User Role info and get the navigation
	 * @param rolName
	 */
    getRolInformation(rolName: string): void {
        this.navItems = [];
        if (rolName === 'staff') {
            const navItems = UtilsService.recursiveDeepCopy(defaultNavItems);
            navItems.splice(2, 0, navMedia);
            this.navItems = navItems;
        }

        if (rolName === 'admin') {
            const navItems = UtilsService.recursiveDeepCopy(defaultNavItems);
            navItems.splice(2, 0, navMedia);
            navItems[7].children.splice(1, 0, navUnits);
            this.navItems = navItems;
        }

        if (rolName === 'user') {
            this.navItems = UtilsService.recursiveDeepCopy(navItemsUserRole);
        }
    }

    ngOnDestroy(): void {
        this.navItems = [];
        this.atComponentDestroy.next();
        this.atComponentDestroy.unsubscribe();
    }
}
